"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _msalBrowser = require("@azure/msal-browser");
var _MsalClientConfig = require("../../api/azure/MsalClientConfig");
var _AzureStatus = require("../../api/azure/AzureStatus");
var _ApplicationContext = require("../../api/ApplicationContext");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const msalInstance = new _msalBrowser.PublicClientApplication((0, _MsalClientConfig.msalConfig)());
class AzureAuthorizationCodeRedirect extends _react.Component {
  render() {
    const azureStatus = _AzureStatus.AzureStatus.get();
    msalInstance.handleRedirectPromise().then(authResult => {
      if (authResult === null) {
        azureStatus.setErrant('Unable to perform authentication at this time (adoa000011)');
      } else if (typeof authResult.account === 'undefined') {
        azureStatus.setErrant('Unable to perform authentication at this time (adoa000012)');
      } else if (typeof authResult.account.name === 'undefined') {
        azureStatus.setErrant('Unable to perform authentication at this time (adoa000013)');
      } else if (typeof authResult.account.username === 'undefined') {
        azureStatus.setErrant('Unable to perform authentication at this time (adoa000014)');
      } else {
        msalInstance.setActiveAccount(authResult.account);
        azureStatus.setAuthReady(authResult.accessToken, authResult.idToken);
      }
      this.props.history.push(_ApplicationContext.ApplicationContext.getLoginPath());
    }).catch(error => {
      // call acquireTokenPopup in case of acquireTokenSilent failure
      // due to consent or interaction required
      if (error.errorCode === 'consent_required' || error.errorCode === 'interaction_required' || error.errorCode === 'login_required') {
        msalInstance.acquireTokenRedirect(_MsalClientConfig.loginRequestDefault).catch(() => {});
      } else {
        azureStatus.setErrant('Unable to perform authentication at this time (adoa000015)');
      }
    });
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null);
  }
}
AzureAuthorizationCodeRedirect.propTypes = {
  location: _propTypes.default.shape({
    search: _propTypes.default.string,
    hash: _propTypes.default.string
  }),
  history: _propTypes.default.shape({
    push: _propTypes.default.func
  })
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(AzureAuthorizationCodeRedirect);
//# sourceMappingURL=AzureAuthorizationCodeRedirect.js.map